import classNames from 'classnames';
import { useMixpanel } from 'gatsby-plugin-mixpanel';
import * as React from 'react';
import { ReactElement } from 'react';
import './style.css';

type IProps = {
  linkType?:
    | 'default'
    | 'mono'
    | 'wrapper'
    | 'button'
    | 'button-secondary'
    | 'button-secondary-purple';
  children: any;
  className?: string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

const Link = ({
  linkType = 'default',
  children,
  className,
  ...props
}: IProps): ReactElement => {
  const mixpanel = useMixpanel();

  const linkClasses = classNames('link', {
    [`link--${linkType}`]: linkType,
    [`${className}`]: className,
  });

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      mixpanel.track('Link clicked', {
        'url location': location.href,
        'destination url': props.href,
        'button description': children,
      });
    }
  };

  return (
    <a className={linkClasses} onClick={handleClick} {...props}>
      {children}
    </a>
  );
};

export default Link;
